<template lang="html">
  <div class="usPage">
    <router-view></router-view>
  </div>
</template>

<script>
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import listKv from '../../components/common/listKv'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	}
</script>

<style lang="less" scoped>
	.usPage{
		// padding-bottom:50px;
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs.vue